<template>
	<section class="page-register">
		<PageHeader title="Registration" />
		<RegisterForm />
	</section>
</template>

<script>
import RegisterForm from "./RegisterForm";
import PageHeader from "../shared/PageHeader";

export default {
	name: "Register",
	components: {
		RegisterForm,
		PageHeader,
	},
};
</script>